import { Component } from '@angular/core';
import { FiDocumentTemplateItemViewBase } from './document-template-item-view-base';

@Component({
    selector: 'fi-document-template-item-view-image',
    template: `<fi-document-layout-item-image
        [item]="data.item"
        [disableEdit]="data.disableEdit"
        [templateLayoutHelper]="data.templateLayoutHelper"
    >
    </fi-document-layout-item-image>`,
    standalone: false,
})
export class FiDocumentTemplateItemViewImageComponent extends FiDocumentTemplateItemViewBase {}
